import {getActingPlayerFromState} from "../players/getActingPlayer";

/**
 * Скрыт ли от этого клиента отряд крысолюдов, нанятый за снабжение
 * (unit.isSupplyRecruit, размер 0 до раздачи). Такой отряд появляется на поле
 * только по итогу фазы снабжения (см. RECRUIT_UNIT), а до тех пор его видит
 * лишь владелец, который раздает ему снабжение. Соперникам, зрителю и записи
 * матча он не рисуется на поле и не показывается в осмотре ячейки — иначе
 * они видели бы отряд размера 0, который может и не появиться.
 *
 * В локальной партии смотрящий — тот, чей ход (getActingPlayer): новобранца
 * бота не видно и тогда, когда ходит сам бот
 *
 * @param {Object|undefined} unit
 * @param {Object} state - redux-состояние клиента
 * @returns {boolean}
 */
export const checkIfSupplyRecruitHiddenFromViewer = (unit, state) => {
  if (!unit?.isSupplyRecruit) {
    return false;
  }
  const viewer = getActingPlayerFromState(state);
  return !viewer || viewer.id !== unit.ownerId || Boolean(viewer.isBot);
};
